import React from 'react';
import { Link } from 'react-router-dom';
// import Aboutus from './Components/Aboutus';

export default function Footer() {
  return (
    <div>
      
      <footer id="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">

          <div class="col-lg-4 col-md-6">
            <div class="footer-info">
              <h3>Insurance Advisors</h3>
              <p>
                1009 F Commercial, <br/>
                LakeCity Meadows (Ex Statelife Housing Society)<br/>
                 LAHORE <br/><br/>
                <strong>Phone:</strong> <a href="tel:03111123026" class="phone-link">03-111-123-026</a> <br/>

                <strong>Email:</strong> <a href="mailto:info@insuranceadvisors.pk" class="email-link">info@insuranceadvisors.pk</a> <br/>

              </p>
              <div class="social-links mt-3">
                {/* <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a> */}
                <a href="https://www.facebook.com/share/19QhjhJrfz/" class="facebook"><i class="bx bxl-facebook"></i></a>
                <a href="https://www.instagram.com/insuranceadvisors.pk?igsh=MW0wdTRqbW92amNueQ==" class="instagram"><i class="bx bxl-instagram"></i></a>
                {/* <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a> */}
                <a href="https://wa.me/+923111123026" class="whatsapp"><i class="bx bxl-whatsapp"></i></a>
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <Link to="/"> Home </Link></li>
              <li><i class="bx bx-chevron-right"></i> <Link to="/about"> About us </Link></li>
              <li><i class="bx bx-chevron-right"></i> <Link to="/contact"> Contact </Link></li>
              <li><i class="bx bx-chevron-right"></i> <a href="/Terms"> Terms of service </a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="/Privacy"> Privacy policy </a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="/Refund"> Refund policy </a></li>

            </ul>
          </div>

          <div class="col-lg-2 col-md-6 footer-links">
            <h4>Our Services</h4>
            <ul>
          
              <li><i class="bx bx-chevron-right"></i> <Link to="/travel"> Travel Insurance </Link></li>
              <li><i class="bx bx-chevron-right"></i> <Link to="/car"> Car Insurance </Link></li>
              <li><i class="bx bx-chevron-right"></i> <Link to="/bike"> Bike Insurance </Link></li>
              <li><i class="bx bx-chevron-right"></i> <Link to="/cartracker"> Car Tracker </Link></li>
              <li><i class="bx bx-chevron-right"></i> <Link to="/health"> Health Insurance </Link></li>
              <li><i class="bx bx-chevron-right"></i> <Link to="/life"> Life Insurance </Link></li>
             
  </ul>
</div>

   <div class="col-lg-4 col-md-6 footer-newsletter">
     <h4>Our Team</h4>
      <p id='pt1'>Our team at Insurance Advisors consists of dedicated professionals committed to providing reliable insurance solutions and personalized support, ensuring you receive the best guidance tailored to your needs. With extensive industry experience, we prioritize transparency and trust in every client interaction.<br/>
      <br/>Feel free to contact us!</p>
      
<a href='/contact' className='btn btn-danger'> Contact </a>
 </div>

        </div>
      </div>
    </div>

    <div class="container">
      <div class="copyright">
        &copy; Copyright <strong><span> Insurance Advisors </span></strong>. All Rights Reserved
      </div>
      <div class="credits">
  Designed by <a href="https://codetechstudio.com" target="_blank" rel="noopener noreferrer">CodeTech Studios</a>
</div>

    </div>
  </footer>

    </div>
  )
}
